import {useState} from 'react'
import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle} from '@/components/ui/dialog'
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from '@/components/ui/select'
import {SaveCancelFooter} from '@/components/shared/SaveCancelFooter'
import {FormField} from '@/components/shared/FormField'
import type {LocalizedTypeValue} from '@/hooks/app-config-helpers'
import {useI18n} from '@/i18n'

interface TypePickerDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    title: string
    description: string
    types: LocalizedTypeValue[]
    testIdPrefix: string
    onPick: (code: string) => void
}

export function TypePickerDialog({
    open,
    onOpenChange,
    title,
    description,
    types,
    testIdPrefix,
    onPick,
}: TypePickerDialogProps) {
    const i18n = useI18n()
    const [selected, setSelected] = useState('')
    return (
        <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) setSelected('') }}>
            <DialogContent data-testid={`${testIdPrefix}-dialog`}>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{description}</DialogDescription>
                </DialogHeader>
                <FormField label={i18n.common.type} htmlFor={`${testIdPrefix}-type`}>
                    <Select value={selected} onValueChange={setSelected}>
                        <SelectTrigger id={`${testIdPrefix}-type`} data-testid={`${testIdPrefix}-type`}>
                            <SelectValue placeholder={description}/>
                        </SelectTrigger>
                        <SelectContent>
                            {types.map((t) => (
                                <SelectItem key={t.code} value={t.code} data-testid={`${testIdPrefix}-type-${t.code}`}>
                                    {t.label}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </FormField>
                <SaveCancelFooter
                    testIdPrefix={testIdPrefix}
                    onCancel={() => onOpenChange(false)}
                    onSave={() => { if (selected) onPick(selected) }}
                    saveType="button"
                    disabled={!selected}
                    saveLabel={i18n.common.next}
                />
            </DialogContent>
        </Dialog>
    )
}
